module.exports = "/_next/static/images/complaint-channel-9ee3f61ed266a6e69ccefda6913b80a5.png";